// PatientHeader.tsx
import React, { useState } from "react";
import { PatientAllergyDto } from "../../types/patientAllergy"; // Βάλε το σωστό path του type σου

interface PatientHeaderProps {
  lastName?: string;
  firstName?: string;
  amka?: string;
  allergies?: PatientAllergyDto[]; // Χρήση του δικού σου DTO
  loading?: boolean;
}

export const PatientHeader: React.FC<PatientHeaderProps> = ({
  lastName,
  firstName,
  amka,
  allergies = [],
  loading = false,
}) => {
  // State για το hover (κρατάμε το patAllId της αλλεργίας)
  const [hoveredAllergyId, setHoveredAllergyId] = useState<number | null>(null);

  // Filter μόνο τις ενεργές αλλεργίες (αν χρειάζεται)
  const activeAllergies = allergies.filter((a) => a.active !== false);

  if (loading) {
    return (
      <div className="bg-white border border-gray-200 rounded-xl p-4 mb-6 shadow-sm animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 mb-6 shadow-sm flex flex-wrap justify-between items-center gap-4">
      {/* Στοιχεία Ασθενή */}
      <div className="flex items-center gap-6">
        <div>
          <span className="text-xs text-gray-400 block uppercase font-medium">
            Ασθενής
          </span>
          <h1 className="text-xl font-bold text-gray-800">
            {lastName || "-"} {firstName || "-"}
          </h1>
        </div>

        <div className="border-l border-gray-200 pl-6">
          <span className="text-xs text-gray-400 block uppercase font-medium">
            ΑΜΚΑ
          </span>
          <span className="text-base font-semibold text-gray-700">
            {amka || "-"}
          </span>
        </div>
      </div>

      {/* Πεδίο Αλλεργιών */}
      <div className="flex items-center gap-2">
        <span className="text-xs text-gray-400 uppercase font-medium mr-2">
          Αλλεργίες:
        </span>

        {activeAllergies.length === 0 ? (
          <span className="text-xs text-gray-500 italic bg-gray-100 px-3 py-1 rounded-full">
            Καμία
          </span>
        ) : (
          <div className="flex flex-wrap gap-2">
            {activeAllergies.map((allergy) => {
              // Επιλογή παρατηρήσεων (προτεραιότητα στις παρατηρήσεις ασθενούς)
              const remarks = allergy.patAllRemarks || allergy.allergyRemarks;

              return (
                <div
                  key={allergy.patAllId}
                  className="relative"
                  onMouseEnter={() => setHoveredAllergyId(allergy.patAllId)}
                  onMouseLeave={() => setHoveredAllergyId(null)}
                >
                  {/* Badge: Προβολή μόνο του allergyDescr */}
                  <span className="bg-red-50 text-red-700 border border-red-200 text-xs font-semibold px-3 py-1 rounded-full cursor-pointer hover:bg-red-100 transition-colors inline-block">
                    {allergy.allergyDescr}
                  </span>

                  {/* Tooltip: Προβολή των παρατηρήσεων στο Hover */}
                  {hoveredAllergyId === allergy.patAllId && remarks && (
                    <div className="absolute right-0 mt-2 w-64 bg-gray-900 text-white text-xs rounded-lg p-3 shadow-xl z-50 pointer-events-none">
                      <p className="font-semibold border-b border-gray-700 pb-1 mb-1 text-red-300">
                        Παρατηρήσεις:
                      </p>
                      <p className="text-gray-200 leading-relaxed whitespace-pre-line">
                        {remarks}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};